import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { propArrayShape, propShape, } from '../../../../helpers/custom-prop-types';
import InputError from '../../Common/InputError';
import PlainInput from '../../Common/PlainInput';
import PlainSelect from '../../Common/PlainSelect';
const PositionFieldsAndLabel = (props) => {
    const { options, position, positionOther } = props;
    const metas = useMemo(() => [position.meta, positionOther.meta], [position.meta, positionOther.meta]);
    const isOther = useMemo(() => {
        const foundOther = options.find((p) => !!p.other) || {};
        return (position.input.value.toString() === (foundOther.value || '').toString());
    }, [options, position.input.value]);
    return (_jsxs("div", Object.assign({ className: 'form form-solution req' }, { children: [_jsx("h3", { children: "\u5F79\u8077" }), _jsxs("div", Object.assign({ className: 'form-flex-split is-half-form' }, { children: [_jsx("div", Object.assign({ className: 'input-form-select' }, { children: _jsx(PlainSelect, { className: 'form-solution-select set-option-height', input: position.input, meta: position.meta, options: options }) })), _jsx(PlainInput, { className: 'input-form-text asign-state', disabled: !isOther, input: positionOther.input, meta: positionOther.meta })] })), _jsx(InputError, { metas: metas })] })));
};
PositionFieldsAndLabel.propTypes = {
    options: propArrayShape().isRequired,
    position: propShape().isRequired,
    positionOther: propShape().isRequired,
};
export default PositionFieldsAndLabel;
